// extracted by mini-css-extract-plugin
export var brandAndCaret = "styles-module--brandAndCaret--c1148";
export var caret = "styles-module--caret--2cbb3";
export var exampleCard = "styles-module--exampleCard--d8f90";
export var exampleCard_whiteText = "styles-module--exampleCard_whiteText--38272";
export var hoverOpenIndicator = "styles-module--hoverOpenIndicator--67e66";
export var title = "styles-module--title--8e702";